import Cookies from "js-cookie";
import { toast } from "react-toastify";
import qs from "query-string";
import jwtDecode from "jwt-decode";
import moment from "moment";
import {
  userStatuses,
  onBoardingStatuses,
  userTypes,
  idOptions,
  genderOptions,
  monthsMapper,
} from "./constants";
import axios from "axios";
import downChart from "assets/images/down-chart.png";
import upChart from "assets/images/up-chart.png";

var CryptoJS = require("crypto-js");

export const encryptData = (data) =>
  CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.REACT_APP_ENCRYPTION_KEY
  ).toString();

export const decryptData = (data) => {
  if (data) {
    var bytes = CryptoJS.AES.decrypt(
      data,
      process.env.REACT_APP_ENCRYPTION_KEY
    );
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
};

export const logOut = () => {
  Cookies.remove("username", { path: "" });
  Cookies.remove("access_token");
  localStorage.removeItem("_expiredTime");
  localStorage.removeItem("access_token");
  localStorage.removeItem("current_user");
  localStorage.removeItem("agentId");
  localStorage.removeItem("onBoardingDone");
  window.location = "/";
  return;
};

export const getAccessToken = () => {
  // const accessToken = Cookies.get("access_token");
  const accessToken = localStorage.getItem("access_token");
  return accessToken ? decryptData(accessToken) : null;
};

export const getDecodedToken = (token) => {
  if (!token) return null;
  return jwtDecode(token);
};

export const checkTokenExpiration = (token) => {
  if (!token) return;
  const decodedToken = getDecodedToken(token);
  const currentTime = parseInt(String(new Date().getTime() / 1000));
  const tokenExpirationTime = decodedToken?.exp;
  if (tokenExpirationTime) {
    return currentTime < tokenExpirationTime;
  }
};

export const isAuthenticated = () => {
  const token = getAccessToken();
  if (token !== undefined && Boolean(token)) {
    return checkTokenExpiration(token);
  }
  return false;
};

export const getUserType = (user) => {
  if (!user) return "";

  if (user.user_type === userTypes.adminUser) return "Admin";

  if (user.is_aggregator === true) return "Aggregator";

  return "Agent";
};

export const isArray = (item) => Array.isArray(item);

export const isObjectValuesEmpty = (obj) => {
  for (var key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false;
  }
  return true;
};

export const removeObjEmptyValues = (obj) => {
  for (var key in obj) {
    if (obj[key] !== 0 && !obj[key]) {
      delete obj[key];
    }
  }
  return obj;
};

export const isObjectEmpty = (obj) =>
  obj &&
  Object.keys(obj).length === 0 &&
  Object.getPrototypeOf(obj) === Object.prototype;

export const objToArrayObj = (obj) => {
  if (!obj) return [];
  return Object.keys(obj).map((key) => ({ key, value: obj[key] }));
};

export const isObjectsEqual = (obj1, obj2) =>
  JSON.stringify(obj1) === JSON.stringify(obj2);

export const isEvenNumber = (number) => number % 2 === 0;

export const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const generateActions = (action) => {
  action = action.toUpperCase();
  return {
    REQUEST: `${action}_REQUEST`,
    SUCCESS: `${action}_SUCCESS`,
    FAILURE: `${action}_FAILURE`,
  };
};

export const setAlert = (msg, type = "error") => {
  if (!msg) return;

  let props = {
    position: "bottom-center",
    theme: "colored",
    hideProgressBar: true,
    autoClose: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
  };
  switch (type) {
    case "success":
      return toast.success(msg, props);

    case "error":
      return toast.error(msg, props);

    default:
      break;
  }
};

export const formatPhoneNumber = (phoneNumber) => "234" + phoneNumber.slice(1);

export const formatDateTime = (date) => {
  if (!date) return "";

  if (date.includes("T")) date = date.split("T")[0];

  return moment(date).format("DD/MM/YYYY");
};

export const formatDateTimeExact = (date, separator = "|") => {
  var dt = new Date(date);
  // console.log(dt.toISOString());

  // console.log(moment(date));
  return moment(dt)
    .subtract(1, "hours")
    .format(`DD/MM/YYYY ${separator} h:mm a`);
};

export const formatDate = (date, splitter = "-") =>
  date && date.split(splitter).reverse().join("-");

export const formatAmount = (amt) =>
  amt ? amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;

export const formatDecimals = (amt) => amt && amt.toFixed(2);
export const truncateString = (word, length = 20) => {
  if (!word) return "";

  return word?.length > length ? `${word?.substring(0, length)}...` : word;
};

export const shortAmountFormat = (amt) => {
  if (!amt) return 0;

  if (amt < 1000) return Math.sign(amt) * Math.abs(amt);

  if (amt >= 1000 && amt < 1000000)
    return Math.sign(amt) * (Math.abs(amt) / 1000).toFixed(1) + "k";

  if (amt >= 1000000 && amt < 1000000000)
    return Math.sign(amt) * (Math.abs(amt) / 1000000).toFixed(1) + "M";

  if (amt >= 1000000000 && amt < 1000000000000)
    return Math.sign(amt) * (Math.abs(amt) / 1000000000).toFixed(1) + "B";
};

export const arrayToValues = (arr) => {
  var last = arr.pop();
  return arr.join(", ") + " or " + last;
};

export const isSuccessResponse = (response) => {
  if (
    response?.responseCode?.toString() === "200" ||
    response?.responseCode?.toString() === "201"
  ) {
    return true;
  }

  return false;
};

export const notFoundStatus = (error) =>
  error?.status?.toString() === "404" ||
  error?.responseCode?.toString() === "404";

export const formatFilterPayload = (filterPayload) => {
  let newFilterState = { ...filterPayload };
  if (newFilterState.startDate) {
    newFilterState.startDate = formatDate(filterPayload.startDate);
  }

  if (newFilterState.endDate) {
    newFilterState.endDate = formatDate(filterPayload.endDate);
  }

  if (newFilterState.createdDateFrom) {
    newFilterState.createdDateFrom = formatDate(filterPayload.createdDateFrom);
  }

  if (newFilterState.createdDateTo) {
    newFilterState.createdDateTo = formatDate(filterPayload.createdDateTo);
  }

  return newFilterState;
};

export const formatUrlQuery = (data) =>
  qs.stringify(removeObjEmptyValues(data));

export const getDataCardColors = (name) => {
  switch (name.toLowerCase()) {
    case "agent":
      return {
        bgColor: "rgba(255, 65, 80, 0.05)",
        textColor: "#FF4150",
      };

    case "aggregator":
      return {
        bgColor: " rgba(108, 93, 211, 0.05)",
        textColor: "#6C5DD3",
      };

    case "pm admin":
      return {
        bgColor: "rgba(39, 174, 96, 0.05)",
        textColor: "#27AE60",
      };

    default:
      break;
  }
};

export const getUserStatus = (status) =>
  status
    ? userStatuses.find(
        (userStatus) =>
          userStatus.mapper === status || userStatus.value === status
      )
    : {};

export const isUserActive = (status) => getUserStatus(status)?.value === 1;

export const isUserInactive = (status) => getUserStatus(status)?.value === 0;

export const isAdminUser = (user) => getUserType(user) === "Admin";

export const isAgentUser = (user) => getUserType(user) === "Agent";

export const isAggregatorUser = (user) => getUserType(user) === "Aggregator";

export const currentOnboardingStatus = (onBoardingStatus) =>
  onBoardingStatuses.find(
    (status) =>
      status.value === onBoardingStatus || status.mapper === onBoardingStatus
  );

export const getGender = (gender) =>
  genderOptions.find((genderOption) => genderOption.value === gender);

export const getIdentificationType = (idType) =>
  idOptions.find((id) => id.value === idType);

export const getAgentId = () =>
  localStorage.getItem("agentId") &&
  decryptData(localStorage.getItem("agentId"));

export const getRegionOptions = (regions) =>
  regions.map((regionOption) => ({
    label: regionOption.name,
    value: regionOption.name,
  }));

export const bvnDateFormatter = (date) => {
  if (!date) return "";
  let splittedDate = date.split("-");
  splittedDate[1] = monthsMapper.find(
    (month) => month.key === splittedDate[1]
  )?.value;

  return splittedDate.reverse().join("-");
};

export const hasPermission = (permission, authorities) =>
  authorities.includes(permission);

export const getCustomMonths = (maxLength = 6) => {
  const d = new Date();

  const currentMonth = d.getMonth();

  // const currentMonth = 6

  const currentYear = d.getFullYear();

  const monthsToSelect = [];

  for (let i = currentMonth; i >= 0; i--) {
    if (monthsToSelect.length < maxLength) {
      monthsToSelect.push(monthsMapper[i].value + ", " + currentYear);
    }

    if (monthsToSelect.length === maxLength) return monthsToSelect;
  }

  const itemsToBeAddedLen = monthsToSelect.length - maxLength;

  if (itemsToBeAddedLen < 0) {
    const itemsToBeAdded = monthsMapper.slice(itemsToBeAddedLen).reverse();

    itemsToBeAdded.forEach((item) =>
      monthsToSelect.push(item.value + ", " + (Number(currentYear) - 1))
    );
  }

  return monthsToSelect;
};

export const getCustomApiDates = (date) => {
  if (!date) return {};

  const dateSelected = date.split(",");

  const monthSelected = dateSelected[0];
  const yearSelected = dateSelected[1].trim();

  const monthObj = monthsMapper.find((month) => month.value === monthSelected);

  //YYY-MM-DD
  return {
    dateFrom: `${yearSelected}-${monthObj.key}-01`,
    dateTo: `${yearSelected}-${monthObj.key}-${monthObj.end}`,
  };
};

export const appendURL = (url, queryParams) =>
  `${url}${queryParams ? `?${queryParams}` : ""}`;

export const downloadFile = (data, fileName, fileType) => {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: fileType || "application/pdf" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

export const downloadFileFromURL = (
  downloadUrl,
  fileExt = "jpg",
  fileName = Date.now()
) => {
  axios({
    url: downloadUrl,
    method: "GET",
    responseType: "blob",
  }).then((response) => {
    const href = URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", `${fileName}.${fileExt}`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  });
};

export const getChartWidth = (dataLength) => {
  if (!dataLength) return "100%";
  if (window.innerWidth < 992) {
    return dataLength < 8 ? "100%" : "160%";
  } else {
    return dataLength < 11 ? "95%" : "160%";
  }
};

export const getPercentageChange = (change) => {
  change = change?.toString();

  if (!change) return {};

  if (change === "0") return { change };
  const isNegativeChange = change.charAt(0) === "-";

  return {
    img: isNegativeChange ? downChart : upChart,
    value: isNegativeChange ? `${change.slice(1)}%` : `${change}%`,
    indicator: isNegativeChange ? "Less" : "More",
  };
};

export const getUniqueTransactionTypes = (transactionTypes) => {
  let uniqueTypes = [];

  transactionTypes?.forEach((transactionType) => {
    if (!uniqueTypes.find((item) => item.type === transactionType.type)) {
      uniqueTypes.push(transactionType);
    }
  });

  return uniqueTypes;
};

export const formatNumber = (number) => {
  // if (number) return '';
  if (typeof number === "number") number = number?.toString();
  // format number 1000000 to 1,234,567
  return number?.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const moneyToNumber = (amount) => {
  if (!amount) return "";

  return Number(amount.replace(/,/g, ""));
};
export const formatCurrency = (
  amount,
  shouldAddCurrency = true,
  currency = "₦"
) => {
  // appends currency to value, validates decimal side

  if (!amount) return "";

  amount = amount?.toString();

  // check for decimal
  if (amount?.indexOf(".") >= 0) {
    // get position of first decimal
    // this prevents multiple decimals from being entered
    var decimalPos = amount.indexOf(".");

    // split number by decimal point
    let leftSide = amount.substring(0, decimalPos);
    let rightSide = amount.substring(decimalPos);

    // add commas to left side of number
    leftSide = formatNumber(leftSide);

    // validate right side
    rightSide = formatNumber(rightSide);

    rightSide = rightSide.substring(0, 2);

    // join number by .
    amount = currency + leftSide + "." + rightSide;
  } else {
    // no decimal entered
    // add commas to number
    // remove all non-digits
    amount = formatNumber(amount);

    amount = shouldAddCurrency ? currency + " " + amount : amount;
  }
  return amount;
};

export const formatCurrencyToNumber = (amount) => {
  if (!amount) return "";
  amount = amount?.toString().replace(/\s+/g, "");
  if (amount.startsWith("₦")) amount = amount.slice(1);

  return moneyToNumber(amount);
};
